import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from './jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.partialUnlockedFilesByJob>>;

export const createFetchPartialUnlockedFilesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getJobPartialUnlockedFiles({ jobId }), signal));
